import { JianList as JianListComponent } from 'core/components/JianList';

export const IncidentListPage = () => {
  return <JianListComponent />;
};
